import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "ImageCriteriasResults";
var classes = {
    grid: "".concat(PREFIX, "-grid"),
    resultsContainer: "".concat(PREFIX, "-resultsContainer")
};
var StyledImageCriteriasResults = styled(Box)(function (_a) {
    var _b, _c, _d;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.grid)] = (_c = {
                display: "grid",
                justifyItems: "center",
                paddingTop: "0px",
                paddingLeft: theme.spacing(8),
                paddingRight: theme.spacing(8)
            },
            _c["".concat(theme.breakpoints.down("sm"))] = {
                paddingLeft: theme.spacing(1),
                paddingRight: theme.spacing(1)
            },
            _c),
        _b["& .".concat(classes.resultsContainer)] = (_d = {
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "100%"
            },
            _d["".concat(theme.breakpoints.down("sm"))] = {
                h5: {
                    marginRight: theme.spacing(2)
                }
            },
            _d),
        _b);
});

export { classes, StyledImageCriteriasResults as default };
//# sourceMappingURL=index.styled.js.map
